import { render, staticRenderFns } from "./crudServices.vue?vue&type=template&id=44155a74&scoped=true&"
import script from "./crudServices.vue?vue&type=script&lang=js&"
export * from "./crudServices.vue?vue&type=script&lang=js&"
import style0 from "./crudServices.vue?vue&type=style&index=0&id=44155a74&prod&lang=css&"
import style1 from "./crudServices.vue?vue&type=style&index=1&id=44155a74&prod&scoped=true&lang=css&"
import style2 from "./crudServices.vue?vue&type=style&index=2&id=44155a74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44155a74",
  null
  
)

export default component.exports